import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { createMultiOptions } from "../../../../utils/createOptions";

const initialState: any = {
  count: 0,
  data: [],
  projects: [],
  currentProject: {},
  pages: 1,
  totalEmps: 0,
  totalPoses: 0,
  totalRoutes: 0,
  limit: JSON.parse(localStorage.getItem("pageLimit") as string) || 10,
  projectsInputValues: {
    managers: [],
  },
};
export const projectSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    reducerGetProjects: (state: Draft<any>, action: PayloadAction<any>) => {
      state.count = action.payload.data.count;
      state.data = action.payload.data.data;
      state.pages = action.payload.data.pages;
      state.totalEmps = action.payload.data.totalEmps;
      state.totalPoses = action.payload.data.totalPoses;
      state.totalRoutes = action.payload.data.totalRoutes;
      state.projects = action.payload.data.data.map((el: any) => el.project);
      state.projectsOptions = action.payload.data.data.map((el: any) => ({
        label: el.project.name,
        value: el.project.id,
      }));
      const temp: any = {};
      action.payload.data.data.map(
        (el: any) => (temp[el.project.id] = el.project.name)
      );
      state.projectsById = temp;
    },
    reducerGetListProjects: (state: Draft<any>, action: PayloadAction<any>) => {
      state.projects = [...action.payload.data.projects];
      state.projectsOptions = action.payload.data.projects.map((el: any) => ({
        label: el.name,
        value: el.id,
      }));
      const temp: any = {};
      action.payload.data.projects.map(
        (el: any) => (temp[el.id] = el.name)
      );
      state.projectsById = temp;
    },
    reducerGetSimplifiedListProjects: (state: Draft<any>, action: PayloadAction<any>) => {
      state.simplifiedProjects = [...action.payload.data.projects];
      state.simplifiedProjectsOptions = action.payload.data.projects.map((el: any) => ({
        label: el.name,
        value: el.id,
      }));
      const temp: any = {};
      action.payload.data.projects.map(
        (el: any) => (temp[el.id] = el.name)
      );
      state.simplifiedProjectsById = temp;
    },
    reducerGetProjectsFilters: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.projectsFilters = action.payload;

      state.managersOptions = createMultiOptions(action.payload.managers);
    },
    reducerProjectsInputValues: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.projectsInputValues = action.payload;
    },
    reducerSetCurrentProject: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.currentProject = action.payload;
    },
    reducerProjectClearValues: () => {
      return initialState;
    },
  },
});

export const {
  reducerGetProjects,
  reducerGetListProjects,
  reducerGetSimplifiedListProjects,
  reducerGetProjectsFilters,
  reducerProjectsInputValues,
  reducerSetCurrentProject,
  reducerProjectClearValues,
} = projectSlice.actions;

export default projectSlice.reducer;
